import { useAtom } from "jotai";
import {
  authAtom,
  remindLocationAtom,
} from "./atoms";
import { Storage } from "../../storage";
import { useCallback, useEffect } from "react";
import User from "../../types/user";

export function useAuth() {
  const [{ data, error, isLoading, isFetching, refetch }] = useAtom(authAtom);
  // const [termsAndConditionsAgreed, setTermsAndConditionsAgreed] = useAtom(
  //   termsAndConditionsAgreedAtom
  // );

  const [remindLocation, setRemindLocation] = useAtom(remindLocationAtom);

  useEffect(() => {
    if (error) {
      console.log("error", error);
      logout();
    }
  }, [error]);

  const isLoggedIn = !!data;

  // const logout = () => {
  //   Storage.delete("currentUser");
  //   refetch();
  // };

  const logout = useCallback(() => {
    Storage.delete("currentUser");
    refetch();
  }, [refetch]);

  return {
    isLoggedIn,
    user: data as User,
    error,
    isLoading,
    isFetching,
    logout,
    remindLocation,
    setRemindLocation,
    isMapper:
      data?.roles?.isSociabilityMapper || data?.roles?.isSociabilityTeam,
      isDerbyUser: data?.roles?.isDerbyUser,
  };
}
